import useTranslation from 'next-translate/useTranslation'
import { useRouter } from 'next/router'
import React from 'react'
import {
  Dispatch,
  SetStateAction,
} from 'react-transition-group/node_modules/@types/react'
import { useMe } from '@/context/meContext'
import { isAdmin } from '@/helpers/adminGuard'
import NavLanguageChanger from '../NavLanguageChanger'
import styles from './styles.module.scss'

interface IProps {
  setMenuVisible: Dispatch<SetStateAction<boolean>>
}

const NavMain = ({ setMenuVisible }: IProps) => {
  const router = useRouter()
  const { t, lang } = useTranslation('common')
  const { me } = useMe()

  const isCurrentPage = (path: string) => router.asPath.includes(path)

  const pages = [
    {
      path: '/for-employers/talent-growth',
      title: t('talent_growth'),
      hiddenOnEnglish: false,
      adminOnly: true,
    },
    {
      path: '/for-employers/pricing',
      title: t('companies_offer'),
      hiddenOnEnglish: false,
    },
    {
      path: '/for-employers/ats-integration',
      title: t('ats'),
      hiddenOnEnglish: false,
    },
    {
      path: '/for-employers/blog',
      title: t('hr_blog'),
      hiddenOnEnglish: false,
    },
    {
      path: '/for-employers/think-it-magazyn-hr',
      title: t('think_it_magazyn'),
      hiddenOnEnglish: true,
    },
  ]

  return (
    <nav className={`${styles.navMain}`}>
      <ul className='xl:flex pt-4 xl:pt-0'>
        <li className={styles.navMain__langChanger}>
          <NavLanguageChanger />
        </li>
        {pages.map((page, index) => {
          if (lang === 'en' && page.hiddenOnEnglish) {
            return null
          }
          if (page.adminOnly && !isAdmin(me)) {
            return null
          }

          return (
            <li key={index}>
              <a
                href={page.path}
                onClick={() => {
                  setMenuVisible(false)
                }}
                className={`${isCurrentPage(page.path) ? 'bg-gray-350' : ''} ${
                  styles.navMain__link
                }`}
              >
                {page.title}
              </a>
            </li>
          )
        })}
        <li>
          <a
            href='/for-employers/job-offers-pricing'
            type='button'
            className={`${styles.navMain__buyButton}`}
          >
            {t('common:buy_offer')}
          </a>
        </li>
        <li>
          {!me && (
            <a
              href='/'
              type='button'
              className={`${styles.navMain__forEmployeeButton}`}
            >
              {t('common:for_employee')}
            </a>
          )}
        </li>
      </ul>
    </nav>
  )
}

export default NavMain
